import z from 'zod';

import { LinkCodec, PlateLink, UnityLink } from './Link';
import { PlateTextItem, TextItemCodec, UnityTextItem } from './TextItem';
import { emptyChildren } from '../commons';
import { ELEMENT_TYPES } from '../constants';

export const UnityTextElements = z.array(z.union([UnityTextItem, UnityLink]));
export const PlateTextElements = z.array(z.union([PlateTextItem, PlateLink]));

const TextOrLink = z.union([TextItemCodec, LinkCodec]);

export const TextElementsCodec = z.codec(UnityTextElements, PlateTextElements, {
    decode: (value) => {
        const items = value;

        if (items.length === 0) {
            // Plate requires at least one text node
            return emptyChildren;
        }

        const children = [];

        const firstItem = items[0];

        // If the first item is a link node, we want to add an empty text node before it
        if (firstItem && firstItem.type !== ELEMENT_TYPES.TEXT_ITEM) {
            children.push(...emptyChildren);
        }

        children.push(...value.map((item) => TextOrLink.decode(item)));

        const lastItem = items.at(-1);

        // If the last item is a link node, we want to add an empty text node after it
        if (lastItem && lastItem.type !== ELEMENT_TYPES.TEXT_ITEM) {
            children.push(...emptyChildren);
        }

        return children;
    },
    encode: (value) => {
        const children = value;

        // if there is only one child and it's an empty text node, we return an empty items array
        if (
            children.length === 1 &&
            children[0] !== undefined &&
            'text' in children[0] &&
            children[0].text === ''
        ) {
            return [];
        }

        const items = value.map((child) => TextOrLink.encode(child));

        const lastItem = items.at(-1);

        // if the last item is an empty text node, we remove it
        if (
            items.length > 1 &&
            lastItem &&
            lastItem.type === ELEMENT_TYPES.TEXT_ITEM &&
            lastItem.text === ''
        ) {
            return items.slice(0, -1);
        }

        return items;
    },
});
